export const RulerSeparator = () => {
  return <hr className='h-0.5 bg-[#9FB7D7] mx-10'></hr>
}
